export const KONSHUS_NAME = "Kōnshus";
export const KONSHUS_VIDEO_URL = "/konshus.mp4";
export const KONSHUS_POSTER_URL = "/konshus-poster.jpg";